import React, { Component } from 'react';
import { connect } from 'react-redux';
import UsersView from '../components/views/Users';
import { withRouter } from '../helpers/withRouter';
import {
  addUser, closeModal, editUser, openModal, removeUser,
  updateModal,
} from '../redux/actions';
import type {
  SingleModalState, State, User, UsersProps,
} from '../types';

class Users extends Component<UsersProps> {
  render(): React.ReactNode {
    return (
      <UsersView
        {...this.props}
      />
    );
  }
}

const mapStateToProps = (state: State) => ({
  currentUser: state.currentUser,
  users: state.users,
  roles: state.roles,
  projects: state.projects.items,
  modal: state.modal,
  vacations: state.vacations,
});

const mapDispatchToProps = dispatch => ({
  onAddUser: (user: User) => dispatch(addUser(user)),
  onEditUser: (user: User) => dispatch(editUser(user)),
  onRemoveUser: (userId: number) => dispatch(removeUser(userId)),
  openModal: (modal: SingleModalState) => dispatch(openModal(modal)),
  closeModal: (modal: SingleModalState) => dispatch(closeModal(modal)),
  updateModal: (modal: SingleModalState) => dispatch(updateModal(modal)),
});

const ConnectedUsers = withRouter(connect(mapStateToProps, mapDispatchToProps)(Users as any));

export default ConnectedUsers;
